import { OrderPaymentMethod } from "../services/orderService";

const STORAGE_PREFIX = "adatis.lastOrderPaymentMethod";

const storageKey = (tenantId: number): string => `${STORAGE_PREFIX}.${tenantId}`;

export const getLastOrderPaymentMethod = (
  tenantId: number
): OrderPaymentMethod | null => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return null;
  }

  try {
    const raw = sessionStorage.getItem(storageKey(tenantId));

    if (!raw) {
      return null;
    }

    return raw as OrderPaymentMethod;
  } catch {
    return null;
  }
};

export const setLastOrderPaymentMethod = (
  tenantId: number,
  method: OrderPaymentMethod
): void => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return;
  }

  try {
    sessionStorage.setItem(storageKey(tenantId), method);
  } catch {
    // sessionStorage unavailable — ignore
  }
};
